// 🚦 A form sent too often is refused with 429 (SEC-017, RateLimitPolicies), and an htmx request is told why in a
// one-line HTML message. htmx 2 swaps nothing for an error, so the form used to just sit there - or, on the MOT scan
// pages, spin "Scanning..." forever. A form that names its result area in data-refusal-target (an aria-live region)
// has that message swapped in there instead, leaving the form, what the visitor typed and an unspent Turnstile token
// where they are. Every other answer, and every other form, is left to htmx as before.
//
// One delegated listener for every htmx page (loaded by __HtmxScript) - in a script file, not an hx-on attribute or an
// inline script the nonce-only CSP would drop (SEC-021, FE-011).
document.addEventListener('htmx:beforeSwap', function (e) {
    var detail = e.detail;
    if (!detail || !detail.xhr || detail.xhr.status !== 429) return;

    var elt  = detail.requestConfig && detail.requestConfig.elt;
    var form = elt && elt.closest ? elt.closest('[data-refusal-target]') : null;
    var area = form ? document.querySelector(form.getAttribute('data-refusal-target')) : null;
    if (!area) return;

    detail.shouldSwap   = true;
    detail.target       = area;
    detail.swapOverride = 'innerHTML';
});
